/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_0_0Inputs */

const en_gc_search_guides_gridcraft_online_sections_3_table_rows_0_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_0_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The launch screen stays visible`)
};

const zh_gc_search_guides_gridcraft_online_sections_3_table_rows_0_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_0_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仍停留在启动页`)
};

/**
* | output |
* | --- |
* | "The launch screen stays visible" |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_0_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_3_table_rows_0_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_0_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_0_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_3_table_rows_0_0(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_3_table_rows_0_0(inputs)
});
export { gc_search_guides_gridcraft_online_sections_3_table_rows_0_0 as "gc.search_guides.gridcraft_online.sections.3.table.rows.0.0" }